import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import './TeacherDetail.css'
import { TeacherConfig } from '../../../configs/stream-entities'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/slide.css'
import { PacmanLoader } from 'react-spinners'
import Alert from 'react-s-alert'
import { defaultTeacherPassword } from '../../../configs/appConfig'
import Dharma from 'src/components/dharma/Dharma';

class TeacherDetailState extends TeacherConfig {
    public forceReset: boolean = false
    public password: string = defaultTeacherPassword
    public showLoader: boolean = false
}

class TeacherDetailProps {
    public teacherId: string
}


class TeacherDetail extends React.Component<TeacherDetailProps, TeacherDetailState> {

    private formRef: React.RefObject<HTMLFormElement>

    constructor(props: TeacherDetailProps) {
        super(props)
        const newState = new TeacherDetailState()
        newState.uuid = props.teacherId
        this.state = newState
        this.formRef = React.createRef<HTMLFormElement>()
        this.onTeacherFirstnameChange = this.onTeacherFirstnameChange.bind(this)
        this.onTeacherLastnameChange = this.onTeacherLastnameChange.bind(this)
        this.onTeacherDescrChange = this.onTeacherDescrChange.bind(this)
        this.onTeacherEmailChanged = this.onTeacherEmailChanged.bind(this)
        this.onTeacherHeaderChange = this.onTeacherHeaderChange.bind(this)
        this.onBgChange = this.onBgChange.bind(this)
        this.onTeacherBioUrlChange = this.onTeacherBioUrlChange.bind(this)
        this.onBannerChange = this.onBannerChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.resetForm = this.resetForm.bind(this)
    }

    public componentWillUpdate(nextProps: TeacherDetailProps, nextState: TeacherDetailState) {
        if (this.props.teacherId !== nextProps.teacherId && !nextState.forceReset) {
            firebase.firestore().collection('users').doc(nextProps.teacherId).get().then(snapshot => {
                nextState.firstname = snapshot.data()!.firstname
                nextState.lastname = snapshot.data()!.lastname
                nextState.email = snapshot.data()!.email
                nextState.header = snapshot.data()!.header
                nextState.description = snapshot.data()!.description
                nextState.photoURL = snapshot.data()!.photoURL
                nextState.isConfirmed = snapshot.data()!.isConfirmed
                nextState.roles = snapshot.data()!.roles
                nextState.bannerURL = snapshot.data()!.bannerURL === undefined ? '' : snapshot.data()!.bannerURL
                nextState.uuid = snapshot.id
                nextState.forceReset = false
                nextState.dharma = snapshot.data()!.dharma === undefined ? '' : snapshot.data()!.dharma
                nextState.dharmaURL = snapshot.data()!.dharmaURL === undefined ? '' : snapshot.data()!.dharmaURL
                nextState.bioVimeoURL = snapshot.data()!.bioVimeoURL === undefined ? '': snapshot.data()!.bioVimeoURL
                this.setState(nextState)
            })
        }
    }

    public render() {
        return (<div className="TeacherDetail">
            <h2>Account Info</h2>
            <button onClick={this.resetForm}>Reset</button>
            <form ref={this.formRef} onSubmit={this.onSubmit}>
                <label htmlFor="teacherFirstname">Teacher Firstname</label><br />
                <input type="text" name="teacherFirstname" onChange={this.onTeacherFirstnameChange} required={true} value={this.state.firstname} />
                <label htmlFor="teacherLastname">Teacher Lastname</label><br />
                <input type="text" name="teacherLastname" onChange={this.onTeacherLastnameChange} required={true} value={this.state.lastname} />
                <label htmlFor="tteacherHeader">Header</label><br />
                <input type="text" name="teacherHeader" onChange={this.onTeacherHeaderChange} required={true} value={this.state.header} />
                <label htmlFor="teacherDescriptionLabel">Description</label><br />
                <textarea name="teacherDescriptionLabel" onChange={this.onTeacherDescrChange} required={true} value={this.state.description} />
                <br />
                <label htmlFor="teacherPhotoLabel">Photo</label><br />
                <input type="text" name="teacherPhotoLabel" required={true} value={this.state.photoURL} onChange={this.onBgChange} />
                <label htmlFor="teacherBannerLabel">Banner Photo (340x170)</label><br />
                <input type="text" name="teacherBannerLabel" required={true} value={this.state.bannerURL} onChange={this.onBannerChange} />
                <label htmlFor="teacherBioUrl">Teacher Bio video (vimeo link)</label><br />
                <input type="text" name="teacherBioUrl" value={this.state.bioVimeoURL} onChange={this.onTeacherBioUrlChange} placeholder="e.g.: https://vimeo.com/326359542" />
                <label htmlFor="teacheremail">Email Address:</label><br />
                <input type="text" name="teacheremail" required={true} value={this.state.email} onChange={this.onTeacherEmailChanged} disabled={this.props.teacherId !== undefined} />
                <label htmlFor="teacherpassword">Password: {this.state.isConfirmed ? '********' : this.state.password}</label><br />
                <br />
                {!this.state.showLoader ? <input type="submit" /> :
                    <div className='popup'>
                        <PacmanLoader css={'display: inline-block;'} loading={true} />
                    </div>}
            </form>
            <h2>teacher share (max 90 char.)</h2>
            <Dharma teacherId={this.state.uuid}/>
            <Alert stack={true} />
        </div>)
    }

    private resetForm(_: any) {
        const newState = new TeacherDetailState()
        newState.forceReset = true
        this.setState(newState)
    }

    private onSubmit(event: React.FormEvent) {
        event.preventDefault()
        if (this.formRef.current!.checkValidity()) {
            this.setState({ showLoader: true })
            const creatTeacher = firebase.functions().httpsCallable('createTeacher')
            creatTeacher(Object.assign({}, this.state)).then(result => {
                if (result.data.result === 'Success') {
                    Alert.success('Teacher added!', {
                        effect: 'slide',
                        position: 'top',
                        timeout: 5000
                    })
                }
                this.setState({ showLoader: false })
            }).catch(err => {
                Alert.error(err.message, {
                    effect: 'slide',
                    position: 'top',
                    timeout: 5000
                })
                this.setState({ showLoader: false })
            })
        }
    }

    private onTeacherFirstnameChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            firstname: event.target.value
        })
    }

    private onTeacherBioUrlChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            bioVimeoURL: event.target.value
        })
    }

    private onTeacherHeaderChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            header: event.target.value
        })
    }

    private onTeacherEmailChanged(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null) {
            event.target.setCustomValidity('')
        } else {
            event.target.setCustomValidity('Invalid Email')
        }
        this.setState({
            email: event.target.value,
            roles: ["teacher"]
        })
    }

    private onTeacherLastnameChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            lastname: event.target.value
        })
    }

    private onTeacherDescrChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ description: event.target.value })
    }

    private onBgChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ photoURL: event.target.value })
    }

    private onBannerChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ bannerURL: event.target.value })
    }

}

export default TeacherDetail


// WEBPACK FOOTER //
// ./src/components/teacher/teacher-detail/TeacherDetail.tsx